module.exports = __webpack_public_path__ + "img/Seedorf.66e1492c.png";